export class GetMSRPPricingError extends Error {
  constructor(error, choices) {
    super(error.message);
    this.name = 'GetMSRPPricingError';
    this.originalError = error;
    this.response = error.response;
    this.choices = choices;
  }
}